var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper"},[_c('div',{staticClass:"content-wrapper bg-light"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row pt-5 pb-5"},[_c('div',{staticClass:"fields col-md-12"},[_c('div',{staticClass:"row"},[_c('List')],1)])])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }